import {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridReferenceCellEditor from "@/components/inputs/AGGridReferenceCellEditor.vue";
import AGGridReferenceCellRenderer from "@/components/inputs/AGGridReferenceCellRenderer.vue";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import Translator from "@/utils/common/Translator.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewReferenceColumn extends AbsAGGridEditViewColumn
{
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridReferenceCellRenderer;
    let isShowCode = this.columnMetadata['pseudoRefSubField'] === 'code';
    colDef.valueFormatter = (params) => {
      const val = params.value;
      if (!val) return '';
      return isShowCode ? Translator.getCode(val) : Translator.getNameForFields(val);
    };
    colDef.comparator = (a, b) => AbsAGGridEditViewColumn.compareReferences(a, b, isShowCode);
    colDef.cellRendererParams = {
      isShowCode: isShowCode,
      referencedEntityType: this.columnMetadata.referencedEntityType,
      columnMetadata: this.columnMetadata,
      columnId: this.id,
      handler: () => this.handler
    }
    colDef.cellEditor = AGGridReferenceCellEditor;
    colDef.cellEditorParams = {
      columnMetadata: this.columnMetadata,
      handler: () => this.handler
    };
    return [colDef];
  }
}
